import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-361e81af"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nps-only"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "uk-icon-info-circle",
  "data-uk-tooltip": "",
  title: "Currently only available for NPS survey results"
}, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "filter-bar-question-type"
}
const _hoisted_4 = { class: "columns options" }
const _hoisted_5 = { class: "option-set" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.npsOnly)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createTextVNode(" NPS "),
        _hoisted_2
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_Dropdown, { ref: "dropdown" }, {
          trigger: _withCtx(() => [
            _createVNode(_component_BaseButton, {
              secondary: "",
              muted: "",
              icon: "chevron-down",
              class: "button-trigger",
              "data-test-tag": "filter-question-type"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedOptionLabel), 1)
              ], undefined, true),
              _: 1
            })
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricOptions, (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: option.label,
                    class: "option",
                    onClick: () => _ctx.setMetricOption(option)
                  }, _toDisplayString(option.label), 9, _hoisted_6))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]))
}